.embeds-onn-video {
  background-color: var(--palette-background-secondary);
  color: var(--palette-foreground-primary);
  display: flex;
  flex-flow: column nowrap;
  gap: 15px;
  padding: 15px 15px 20px;
  position: relative;

  @include use-dziub-dziub($color: var(--palette-background-secondary), $slot: after);

  &__title {
    display: block; 
    font: use-font-accent("700 16px/20px");
    text-transform: uppercase;
  }

  &__description {
    display: block;
    font: use-font-secondary("700 18px/24px");
    margin-top: -5px;
  }

  &__player {
    aspect-ratio: 16 / 9;
    background-color: var(--palette-background-primary);
    border: none;
  }
}
